<p class="title">
    <img class="icon-title" src="assets/images/edit.svg" alt="Image" />
    {{ texts.titulo }}
  </p>
  <div class="container">
    <div id="mainDiv" class="main-div form-div">
      <div id="mainDiv" class="form-container">
        <div class="form-column">
          <div class="form-item">
            <label>{{ texts.observacao }}</label>
            <input [(ngModel)]="form.observacao" type="text" pInputText [placeholder]="placeholders.observacao" />
          </div>
          <div class="form-item">
            <label>{{ texts.conta_origem }}</label>
            <p-dropdown
              [options]="contasOptions"
              optionLabel="label"
              [placeholder]="placeholders.selecione"
              [(ngModel)]="form.conta_id"
              optionValue="value"
              [filter]="true"
              [showClear]="false">
              <ng-template pTemplate="dropdownicon">
                <i class="pi pi-chevron-down"></i>
              </ng-template>
              <ng-template pTemplate="selectedItem" let-conta>
                <div class="dropdown-conta-item" *ngIf="conta">
                  <img *ngIf="conta.flagUrl" [src]="conta.flagUrl" class="flag-icon-small" alt="" />
                  <span>{{ conta.label }}</span>
                </div>
              </ng-template>
              <ng-template pTemplate="item" let-conta>
                <div class="dropdown-conta-item">
                  <img *ngIf="conta.flagUrl" [src]="conta.flagUrl" class="flag-icon-small" alt="" />
                  <span>{{ conta.label }}</span>
                </div>
              </ng-template>
            </p-dropdown>
          </div>
          <div class="form-item">
            <label>{{ texts.conta_destino }}</label>
            <p-dropdown
              [options]="contasOptions"
              optionLabel="label"
              [placeholder]="placeholders.selecione"
              [(ngModel)]="form.contaDestino_id"
              optionValue="value"
              [filter]="true"
              [showClear]="false">
              <ng-template pTemplate="dropdownicon">
                <i class="pi pi-chevron-down"></i>
              </ng-template>
              <ng-template pTemplate="selectedItem" let-conta>
                <div class="dropdown-conta-item" *ngIf="conta">
                  <img *ngIf="conta.flagUrl" [src]="conta.flagUrl" class="flag-icon-small" alt="" />
                  <span>{{ conta.label }}</span>
                </div>
              </ng-template>
              <ng-template pTemplate="item" let-conta>
                <div class="dropdown-conta-item">
                  <img *ngIf="conta.flagUrl" [src]="conta.flagUrl" class="flag-icon-small" alt="" />
                  <span>{{ conta.label }}</span>
                </div>
              </ng-template>
            </p-dropdown>
          </div>
        </div>

        <div class="form-column">
          <div class="form-item">
            <label>{{ texts.moeda_de_origem }}</label>
            <p-dropdown
              [options]="moedas"
              optionLabel="label"
              [placeholder]="placeholders.selecione"
              [(ngModel)]="form.moedaDeOrigem"
              (onChange)="loadCotacao()"
            ></p-dropdown>
          </div>
          <div class="form-item">
            <label>{{ texts.moeda_de_destino }}</label>
            <p-dropdown
              [options]="moedas"
              optionLabel="label"
              [placeholder]="placeholders.selecione"
              [(ngModel)]="form.moedaDeDestino"
              (onChange)="loadCotacaoDeTransferencia()"
            ></p-dropdown>
          </div>
          <div class="form-item">
            <label>{{ texts.valor }}</label>
            <input [(ngModel)]="form.valor" type="number" pInputText [placeholder]="placeholders.valor" />
          </div>
        </div>

        <div class="form-column">
          <div class="form-item">
            <label>{{ texts.cotacao_de_transferencia }}</label>
            <input [(ngModel)]="form.cotacaoDeTransferencia" type="number" pInputText [placeholder]="placeholders.cotacao" disabled />
          </div>
          <div class="form-item">
            <label>{{ texts.valor_convertido }}</label>
            <input [(ngModel)]="form.valorConvertido" type="number" pInputText [placeholder]="placeholders.valor_convertido" />
          </div>
        </div>

        <div class="actions-container">
          <button pButton [label]="botoes.salvar" icon="pi pi-check" (click)="submit()" class="btn-primary"></button>
        </div>
      </div>
    </div>
  </div>
